import {UploadFile} from '@/components/molecules'
import {Constants} from '@/utils/constants/commonConstants'
import {useState} from 'react'
import {Toggle} from '@/components/atoms'

export const ImageOptimization = () => {
  const [formData, setFormData] = useState('')
  let [toggleValue, setToggleValue] = useState(false)
  const [imgUrl, setImageUrl] = useState('')
  const [orgUrl, setOriginalIgm] = useState('')
  const [imgSize, setOriginalIgmSize] = useState('')
  const [imgSizeNew, setIgmSize] = useState('')

  const [value, setValue] = useState({height: '', width: ''})

  const handleDelete = () => {
    setFormData(prev => ({...prev, ...{targetMediaFile: []}}))
  }
  const convertFileToImageurl = file => {
    setOriginalIgm(URL.createObjectURL(file))
  }
  const convertBlobToFile = (blob, fileName) => {
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now(),
    })
    setIgmSize(file?.size)
    return file
  }

  const convertImageToWebP = async file => {
    setOriginalIgmSize(file?.size)
    const imageUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = event => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          canvas.toBlob(
            blob => {
              if (blob) {
                resolve(blob)
              } else {
                reject(new Error('Conversion to WebP failed'))
              }
            },
            'image/webp',
            0.7 // Quality parameter from 0 to 1
          )
        }
        img.src = event.target.result
      }
      reader.readAsDataURL(file)
    })
    convertBlobToFile(imageUrl, file.name)
    const url = URL.createObjectURL(imageUrl)
    setImageUrl(url)
  }

  const onUpdate = e => {
    const {name, value} = e.target
    setValue(prevValue => ({
      ...prevValue,
      [name]: value,
    }))
  }

  return (
    <div>
      <div className="flex justify-between">
        <div>
          Before
          <img src={orgUrl} />
          <span>{imgSize}</span>
        </div>
        <div>
          After
          <img
            style={{
              maxWidth: `${value.width}px` ?? '300px',
              maxHeight: `${value.height}px` ?? '300px',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              imageRendering: 'auto',
            }}
            src={imgUrl}
          />
          <span>{imgSizeNew}</span>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-center justify-center">
        <UploadFile
          acceptedExtensions={'.png'}
          description={'test'}
          label={Constants.UploadStoresFile}
          variant={Constants.Edit}
          feedbackType={Constants.Info}
          required={true}
          files={formData?.targetMediaFile?.length > 0 ? [formData?.targetMediaFile] : []}
          onUpload={file => {
            setFormData(prev => ({...prev, ...{targetMediaFile: [file?.name]}}))
            convertImageToWebP(file)
            convertFileToImageurl(file)
          }}
          onUploadDelete={handleDelete}
          // helperText={uploadError ? 'File format is not valid. Supported formats: .csv' : ''}

          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          containerClassName={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          dataTestId="upload-file"
        />
        <div className="mt-12">
          <Toggle
            uiSchema={{isDark: true, label: 'is width and height manual', size: 'medium'}}
            updateValue={() => setToggleValue(!toggleValue)}
            value={toggleValue}
          />
          {toggleValue && (
            <div className=" flex flex-col">
              <input
                onChange={onUpdate}
                type="text"
                placeholder="enter your image width"
                value={value.width}
                className="mt-8 text-black"
                name="width"
              />
              <input
                onChange={onUpdate}
                type="text"
                placeholder="enter your image height"
                value={value.height}
                className="mt-8 text-black"
                name="height"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ImageOptimization
